import { createContext } from 'react';

export const LaundryBrikkModalContext = createContext();
